import * as z from "zod";

export const RecommendationModeSchema = z.enum([
  "single",
  "multiple",
  "hero-then-alternatives",
]);

export type RecommendationMode = z.infer<typeof RecommendationModeSchema>;

export function resolveRecommendationMode({
  recommendationMode,
  recommendMultipleProducts,
}: {
  recommendationMode?: RecommendationMode | null;
  recommendMultipleProducts?: boolean;
}): RecommendationMode {
  return (
    recommendationMode ?? (recommendMultipleProducts ? "multiple" : "single")
  );
}
